import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import { ContentBlockerField, EContentBlockerVisualType, EExtendsMergeStrategy, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { VISUAL_CONTENT_HERO_TYPES } from "./visual-content-type.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { useStores } from "../../../../../../store/root.js";
import { defaultTranslationFlexNamePath } from "../../../../../../util/template/form.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { getInputPropsDefaultLang, hasTranslationFlagsChanged } from "../../../../../../util/translation.js";
import { TranslationInputFormFields } from "../../fields/translation/language-input/language-input-form-fields.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
const FormFieldContentBlockerTemplateVisualHeroButtonText = observer(()=>{
    const { t } = useTranslation();
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const { isTranslationMode } = translationSettings;
    // Triggers form item re-render on translation mode toggle
    const lastKnownTranslationMode = isTranslationMode;
    const form = Form.useFormInstance();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.VisualHeroButtonText,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.isVisual !== next.isVisual || prev.visualType !== next.visualType || prev.visualContentType !== next.visualContentType || prev.extends?.identifier !== next.extends?.identifier || hasTranslationFlagsChanged(prev, next, ContentBlockerField.VisualHeroButtonText) || lastKnownTranslationMode !== isTranslationMode,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                const isHeroType = getFieldValue("visualType") === EContentBlockerVisualType.Hero || getFieldValue(TemplateMetaDataField.Extends)?.["visualType"] === EContentBlockerVisualType.Hero;
                const isHeroContentType = VISUAL_CONTENT_HERO_TYPES.includes(getFieldValue("visualContentType")) || VISUAL_CONTENT_HERO_TYPES.includes(getFieldValue(TemplateMetaDataField.Extends)?.["visualContentType"]);
                return isHeroType && isHeroContentType && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ContentBlockerField.VisualHeroButtonText, t),
                    extra: t("If you specify a button text, a button with this text will be centered in the image and only when you click on this button the content blocker will be opened. Otherwise, clicking on the image itself will open the content blocker."),
                    children: /*#__PURE__*/ _jsxs(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ContentBlockerField.VisualHeroButtonText,
                        disableStrategies: [
                            ...getDisableStrategies()
                        ],
                        defaultStrategy: EExtendsMergeStrategy.Overwrite,
                        onKeepContent: extended && /*#__PURE__*/ _jsx(Input, {
                            readOnly: true,
                            value: extended[ContentBlockerField.VisualHeroButtonText]
                        }),
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                rules: [
                                    {
                                        max: 255
                                    }
                                ],
                                hasFeedback: true,
                                name: ContentBlockerField.VisualHeroButtonText,
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Input, {
                                    maxLength: 255,
                                    ...getInputPropsDefaultLang(translationSettings, ContentBlockerField.VisualHeroButtonText, form)
                                })
                            }),
                            /*#__PURE__*/ _jsx(TranslationInputFormFields, {
                                flexPathConfig: {
                                    absolute: {
                                        namePath: defaultTranslationFlexNamePath(ContentBlockerField.VisualHeroButtonText)
                                    }
                                },
                                inputProps: {
                                    maxLength: 255
                                }
                            })
                        ]
                    })
                });
            }
        })
    });
});
export { FormFieldContentBlockerTemplateVisualHeroButtonText };
